import React, { useState } from "react";
import { Draggable } from "react-beautiful-dnd";
import OrderDetails from "./OrderDetails";
import axios from "axios";
import Modal from "./Modal";

export default function OrderCard({
  order,
  index,
  expanded,
  onToggle,
  setIsAnyModalActive,
  refetchOrders,
}) {
  const [showCancelModal, setShowCancelModal] = useState(false);
  const [loading, setLoading] = useState(false);

  const openCancelModal = (e) => {
    e.stopPropagation();
    setShowCancelModal(true);
    setIsAnyModalActive?.(true);
  };

  const closeCancelModal = () => {
    if (loading) return;
    setShowCancelModal(false);
    setIsAnyModalActive?.(false);
  };

  const handleCancelOrder = async (e) => {
    e.preventDefault();
    if (loading) return;

    setLoading(true);

    try {
      await axios.post("https://admin-new.lasgidirestaurant.com/php/cancel-order.php", {
        order_id: order.id,
      });

      if (refetchOrders) {
        await refetchOrders();
      }

      closeCancelModal();
    } catch (err) {
      console.error("Failed to cancel order:", err);
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <Draggable draggableId={order.id.toString()} index={index}>
        {(provided) => (
          <li
            className={`order-card ${expanded ? "expanded" : ""}`}
            ref={provided.innerRef}
            {...provided.draggableProps}
            {...provided.dragHandleProps}
            onClick={onToggle}
          >
            <div className="order-date">
              <span className="order-date-text">
                {new Date(order.created_at).toLocaleDateString("en-GB")}
              </span>
              <span className="order-id">ID: {order.id}</span>
            </div>

            <div className="order-header">
              <div className="order-header-left">
                <div className="order-header-top">
                  <p>
                    <strong>Order #{order.order_number}</strong>
                  </p>
                  {order.order_type === "Eat In" && order.table_number && (
                    <p>
                      <strong>Table: </strong> {order.table_number}
                    </p>
                  )}

                  <p>
                    <strong>{order.order_type}</strong>
                  </p>
                </div>

                <div className="order-header-bottom">
                  <p>
                    <strong>Customer Name: </strong>
                    {order.customer_name || "Unnamed Customer"}
                  </p>
                  <p className="order-total">
                    <strong>£{parseFloat(order.total_price).toFixed(2)}</strong>
                  </p>
                </div>
              </div>

              {/* Cancel icon */}
              <div className="order-header-right">
                <i
                  className="fas fa-times-circle cancel-order-icon"
                  onClick={openCancelModal}
                  title="Cancel Order"
                />
              </div>
            </div>

            {expanded && <OrderDetails order={order} />}
          </li>
        )}
      </Draggable>

      {/* Cancel Modal */}
      {showCancelModal && (
        <Modal
          title="Cancel Order"
          onClose={closeCancelModal}
          onSubmit={handleCancelOrder}
          showCancel={false}
          showSubmitButton={true}
          submitButtonText={
            loading ? (
              <span className="modal-spinner">
                <i className="fas fa-spinner fa-spin" /> Cancelling…
              </span>
            ) : (
              "Notified customer, Proceed"
            )
          }
          className="cancel-order-modal"
        >
          <div className="delete-modal-heading">
            <p>
              Are you sure you want to cancel this order?
              <br />
              Please notify customer on: <strong>{order.customer_phone}</strong>
            </p>
          </div>
        </Modal>
      )}
    </>
  );
}
